import { GridApi } from "ag-grid-community";
import { Injectable } from "@angular/core";
import { IServerSideRequestOptions } from "../data-source.interfaces";
import { BsshDataTableApiService } from "./bssh-data-table-api-service.service";
import { Observable } from "rxjs";

@Injectable()
export class BsshDataTableServerSideDatasourceService {
  apiDriver: BsshDataTableApiService;
  gridInstance: GridApi;
  requestOptions: IServerSideRequestOptions;

  constructor() { }

  init(
    initOptions: {
      apiDriver: BsshDataTableApiService;
      gridInstance: GridApi;
      requestOptions?: IServerSideRequestOptions,
      initialQuery?: Observable<any>;
    }
  ) {
    const { apiDriver, gridInstance, requestOptions } = initOptions;

    this.apiDriver = apiDriver;
    this.gridInstance = gridInstance;
    this.requestOptions = requestOptions;

    this.gridInstance.setServerSideDatasource(this);
  }

  getRows(params: any) {
    this.apiDriver.getData(this.requestOptions, params.request, this.gridInstance)
      .subscribe((data: any) => {
        if (Array.isArray(data.rowData)) {
          params.successCallback(data.rowData, data.lastRow);
        }
      }, (error) => {
        params.failCallback(error);
      });

    return this;
  }
}
